
import StateBlock from '@/components/ui/StateBlock.vue';
import { defineComponent } from 'vue';
import { apiGet, apiPatch, apiPost } from "@/services/api/client";
import { Incident, IncidentEntry, IncidentStatus } from 'shared/Incident';
import { formatDateToUTC } from "@/utils/format";
import BaseModal from '@/components/ui/BaseModal.vue';

export default defineComponent({
  name: 'IncidentLogComponent',
  components: { BaseModal, StateBlock },
  data() {
    return {
      incidents: [] as Incident[],
      selectedIncident: null as Incident | null,
      showCreate: false,
      showEntryModal: false,
      newIncident: { title: '', description: '', status: 'open' as IncidentStatus, createdAt: '' },
      newEntry: { author: '', message: '', createdAt: '' },
      statusUpdate: 'open' as IncidentStatus,
    };
  },
  computed: {
    sortedEntries(): IncidentEntry[] {
      if (!this.selectedIncident) return [];
      return [...this.selectedIncident.entries].sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
    }
  },
  async mounted() {
    await this.fetchIncidents();
  },
  methods: {
    async fetchIncidents() {
      this.incidents = await apiGet('/incidents');
    },
    goToIncident(incident: Incident) {
      this.$router.push(`/admin/incidents/${incident._id}`);
    },
    formatDate(date: string | number) {
      return formatDateToUTC(date, (this as any).$i18n?.locale);
    },
    async createIncident() {
      if (!this.newIncident.title || !this.newIncident.description) return;
      const payload = { ...this.newIncident } as Partial<typeof this.newIncident>;
      if (!payload.createdAt) delete payload.createdAt;
      const incident = await apiPost('/incidents', payload) as Incident;
      this.incidents.unshift(incident);
      this.showCreate = false;
      this.newIncident = { title: '', description: '', status: 'open', createdAt: '' };
    },
    async addEntry() {
      if (!this.selectedIncident || !this.newEntry.author || !this.newEntry.message) return;
      const payload = { ...this.newEntry } as Partial<typeof this.newEntry>;
      if (!payload.createdAt) delete payload.createdAt;
      const entry = await apiPost(`/incidents/${this.selectedIncident._id}/entries`, payload) as IncidentEntry;
      this.selectedIncident.entries.push(entry);
      this.showEntryModal = false;
      this.newEntry = { author: '', message: '', createdAt: '' };
    },
    async updateStatus() {
      if (!this.selectedIncident) return;
      const previous = this.selectedIncident.status;
      this.selectedIncident.status = this.statusUpdate;
      const idx = this.incidents.findIndex(i => i._id === this.selectedIncident!._id);
      if (idx !== -1) this.incidents[idx].status = this.statusUpdate;
      try {
        await apiPatch(`/incidents/${this.selectedIncident._id}/status`, { status: this.statusUpdate });
      } catch (e) {
        this.selectedIncident.status = previous;
        if (idx !== -1) this.incidents[idx].status = previous;
        alert(this.$t('panel.incidents.errors.updateStatus'));
      }
    },
  },
});
